module.exports = __webpack_public_path__ + "media/direct_cabinet_n2.a200ad55.wav";